/** Tracks in-flight UI operations by key so controls can give local feedback. */
export class OperationState {
  private readonly active = new Set<string>()

  begin(key: string): boolean {
    if (this.active.has(key)) {
      return false
    }
    this.active.add(key)
    return true
  }

  end(key: string): void {
    this.active.delete(key)
  }

  isPending(key: string): boolean {
    return this.active.has(key)
  }
}
